import Content, { ContentNS } from "content/content";
import usePaxSession from "features/shared/hooks/usePaxSession";
import ChecklistItem from "models/checklist/checklist-item/checklist-item";

import {
  getVisaRequirementReason,
  VisaRequirementReason,
} from "./visa-requirement-reason";

/*
Whether - and why - the visa banner would show for this item. Shared between
VisaBanner (which renders it) and the page layout that hosts it (which needs
to know in advance whether to reserve a spot for it, since the banner and the
item's info card share a grid with the automated-tools card).
*/
const useVisaBannerReason = (
  item: ChecklistItem | undefined
): VisaRequirementReason | null => {
  const paxSession = usePaxSession();

  if (!item || !paxSession) {
    return null;
  }

  const hasContent = Content.shared.instance.exists("visa-banner.title", {
    ns: ContentNS.docs,
  });

  if (!hasContent) {
    return null;
  }

  return getVisaRequirementReason(item, paxSession.checklist.questions);
};

export default useVisaBannerReason;
